import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "location" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "detail-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "list-name",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('return-list')))
      }, _toDisplayString(_ctx.listName), 1),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "char" }, "/", -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.detailName), 1)
    ])
  ]))
}